import { render, staticRenderFns } from "./rental_price.vue?vue&type=template&id=3f63f5a2"
import script from "./rental_price.vue?vue&type=script&lang=js"
export * from "./rental_price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports